import React from 'react';
import { mesComptencesFields } from '../../../domain/note/mesCompetences';
import { ElevesDashboardProf } from '../../../types/classe/maClasse';
import { TableData } from '../../../components/organisms/Table/TableData';
import { TableDateLineCompetences } from '../../../components/organisms/Table/TableData/TableDataLineCompetences';
import { Competence } from '../../../types/note/note.def';

export interface EleveCompetences {
  firstname: string;
  lastname: string;
  competences: Competence[];
}

interface CompetencesTabProps {
  eleves: ElevesDashboardProf[];
}

export const CompetenceTab = ({ eleves }: CompetencesTabProps) => {
  const eleveCompetences: EleveCompetences[] = eleves.map(eleve => {
    if (!eleve.note) return null;

    return {
      firstname: eleve.firstname,
      lastname: eleve.lastname,
      competences: mesComptencesFields(eleve.note)
    };
  });
  if (eleveCompetences.length === 0) return null;
  const tabLabels = [
    'Élèves',
    'Implication',
    'Adaptation aux consignes',
    'Dépassement de soi',
    "Curiosité, envie d'apprendre",
    'Négocier en B TO C',
    'Négocier en B TO B'
  ];

  return (
    <TableData tabLabels={tabLabels}>
      {eleveCompetences.length !== 0 &&
        eleveCompetences
          .sort((a, b) => a.lastname.localeCompare(b.lastname))
          .map((el, i) => {
            if (el && !el.competences) return null;
            return <TableDateLineCompetences eleveCompetences={el} key={i} />;
          })}
    </TableData>
  );
};
